import { render, staticRenderFns } from "./ListNotifications.vue?vue&type=template&id=f60b6dc0"
import script from "./ListNotifications.vue?vue&type=script&lang=js"
export * from "./ListNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListNotifications.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f60b6dc0')) {
      api.createRecord('f60b6dc0', component.options)
    } else {
      api.reload('f60b6dc0', component.options)
    }
    module.hot.accept("./ListNotifications.vue?vue&type=template&id=f60b6dc0", function () {
      api.rerender('f60b6dc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ListNotifications.vue"
export default component.exports